import { Popover } from '@rossum/ui/material';
import { Suggester, SuggesterProps } from './Suggester';

export type SuggesterPopoverMode = 'fstring' | 'formula';

export type SuggesterPopoverProps = {
  open: boolean;
  anchorEl: HTMLButtonElement | null;
  onClose: () => void;
} & SuggesterProps;

/**
 * Reusable popover component for template suggestion across different form fields.
 * Eliminates the need for multiple identical Popover components.
 */
export const SuggesterPopover = ({
  mode,
  open,
  anchorEl,
  onClose,
  onInsert,
  sections,
}: SuggesterPopoverProps) => (
  <Popover
    open={open}
    onClose={onClose}
    anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
    transformOrigin={{ horizontal: 'right', vertical: 'top' }}
    anchorEl={anchorEl}
    slotProps={{
      paper: {
        elevation: 4,
        sx: {
          mt: 0.5,
          width: 'fit-content',
          minWidth: 400,
          maxHeight: 465,
        },
      },
    }}
  >
    <Suggester
      mode={mode}
      onInsert={insertValue => {
        onInsert(insertValue);
        onClose();
      }}
      sections={sections}
    />
  </Popover>
);
